import { create, StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type Initializer<T extends Record<string, unknown>> = StateCreator<
  T,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  T
>;

export const createImmerStore = <T extends Record<string, unknown>>(initializer: Initializer<T>) =>
  create(immer(devtools(initializer, { enabled: typeof window !== 'undefined' })));
